/* ---------------------------------------------------------------------------
   ll-globals.js — Little Laurel site-wide behaviour.
   Loaded deferred from layout/theme.liquid.

   Currently one job: replay the header icon hover animation on tap, for touch
   devices that never match @media (hover: hover). See ll-globals.css.
   --------------------------------------------------------------------------- */
(function () {
  var HOVERABLE = window.matchMedia('(hover: hover) and (pointer: fine)');
  var TARGETS = '.header__icon--cart, .ll-wishlink';
  var DURATION = 520; // longest animation is the 80ms-delayed 420ms bubble pop

  // Delegated on document, not bound per element: the cart icon and its count
  // bubble are re-rendered when the drawer updates, and directly bound
  // listeners would be lost on the replaced nodes.
  document.addEventListener('pointerdown', function (e) {
    if (HOVERABLE.matches) return;          // desktop already has :hover
    if (!e.target || !e.target.closest) return;

    var el = e.target.closest(TARGETS);
    if (!el) return;

    // Remove, force a reflow, re-add — otherwise a second tap inside the
    // animation window does nothing, because the class never actually changed.
    el.classList.remove('ll-tap');
    void el.offsetWidth;
    el.classList.add('ll-tap');

    clearTimeout(el._llTapTimer);
    el._llTapTimer = setTimeout(function () {
      el.classList.remove('ll-tap');
    }, DURATION);
  }, { passive: true });
})();
